import { Box, Button } from '@mui/material';

import Icon from '@toolbox/components/Timeslots/Icon';

import type { PhoneLinkBtnProps } from '@toolbox/components/PhoneLink/PhoneLink';

export const PhoneLinkBtn = ({ phoneCTA, ...props }: PhoneLinkBtnProps) => {
  return (
    <Button
      href={`tel:${phoneCTA?.tel}`}
      disableElevation
      fullWidth={false}
      size={'medium'}
      role={'button'}
      {...props}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        color: 'inherit',
        borderRadius: 0,
        width: { lg: '300px', md: '300px', sm: '100%' },
        ...props.sx,
      }}
    >
      <Box sx={{ paddingRight: '8px' }}>
        <Icon icon="phone" sx={[{ fontSize: '24px', fontWeight: '900' }]} />
      </Box>

      <span style={{ fontSize: '16px', fontWeight: 700, whiteSpace: 'nowrap' }}>
        {phoneCTA?.text}
      </span>
    </Button>
  );
};
